import React, { memo, Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Numeral from 'numeral';

import { SiteRutas, ImagenesRutas } from "../../request/RutasConfig";
import Config from '../../components/Util/Constantes';
import ConsultaRepartidoresInt from "./Interfaz/consultaRepartidoresInt.jsx";
import {
    AR_Obtener_Productos_Ordenes, AR_Repartidor_En_Ruta, AR_Obtener_Productos_Orden, AR_Desasignar_Repartidor, AR_Asignar_Repartidor, Obtener_Configuraciones,
    Obtener_Ordenes_Sin_Asignar, Obtener_Repartidores, Guardar_Entrega_Repartidores, Eliminar_Orden_Entrega_Ruta
} from "../../request/ProcesosRequest"
import { ParametroCallCenter_Detalle, Repartidor_Detalle } from "../../request/MantenimientosRequest";
import { Obtener_MenuOpciones } from "../../request/MenuRequest";
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { Orden, Repartidor, Constantes } from './ConsultaRepartidoresSvc';
import ModalSeguridad from '../Seguridad/ModalSeguridad.jsx';
import LocalStorage from '../../components/Util/LocalStorage/LocalStorage';
import { Obtener_Estado_Active_Directory_Request } from '../../request/ParametroRequest';

const localStorageObject = new LocalStorage();

window.fireUpdate = function (orderId) {
    window.orderToUnassign = orderId;
};

class ConsultaRepartidores extends Component {
    dataUpdate = null;
    _isMounted = false;

    state = {
        activoAD: false,
        fecha_activa: new Date(),
        listaOrdenes: [],
        listaOrdenesFilradas: [],
        filtro: '',
        center: [0, 0],
        bingmapKey: "",
        infoboxes: [],
        pushPins: [],
        configuraciones: null,
        directions: {},
        articulosTotales: [],
        viewAs: { List: false, Map: true },
        repartidores: null,
        repartidorList: [],
        userWorkspace: {
            selectedOrder: null,
            selectedCourier: null
        },
        modals: {
            RouteModal: { show: false, action: "", checks: { chkCopiaCaja: false, chkImprimirDetalle: false } },
            ProductsModal: { show: false, action: "", products: [], order: {} },
            PrintModal: { show: false, action: "" }
        },
        parametrosCallCenter: null,
        collapsibles: {
            repSinAsignar: { show: true },
            repAsignados: { show: true },
            repNoDisp: { show: true },
            repEnRuta: { show: true }
        },
        loading: true,
        mapRenderKey: 1,
        actualizacionMonitor: { notificar: false, mensaje: "Se actualizó el monitor" },
        mensajesError: {
            repartidor: {
                limiteExcedido: { monto: "El monto que intenta asignar a este repartidor excede el límite definido en parámetros de Call Center.", cantidadOrdenes: "La acción excede el límite de órdenes asignadas a un repartidor definido en parámetros de Call Center." },
                indefinido: { ordenSeleccionada: "Debe seleccionar una orden.", repartidorSeleccionado: "Debe seleccionar un repartidor." }
            },
        },
        infoRoutes: [],
        showModalSeguridad: false,
        menuId: -1,
        opcionId: -1,
        opcionesMenu: [],
        eventTarget: {},
        unassignOrder: null
    }

    componentDidMount = async () => {
        this._isMounted = true;
        localStorageObject.set("UID", -1);

        let mensajeValidacion = '';
        //  No se definio un call center en parámetros
        if (this.props.callCenter.Id <= 0) {
            mensajeValidacion = 'No se ha seleccionado un call center en los parámetros';
        }
        //  No se definio sucursal en parámetros
        if (this.props.sucursal.Id <= 0) {
            if (mensajeValidacion.length > 0) {
                mensajeValidacion = 'No se ha seleccionado call center ni sucursal en los parámetros';
            } else {
                mensajeValidacion = 'No se ha seleccionado una sucursal en los parámetros';
            }
        }

        //  No se definió algún parámetro
        if (mensajeValidacion.length > 0) {
            Notificacion.error(mensajeValidacion);
            this.props.history.replace(SiteRutas.Home);
            return false;
        }

        this.obtenerEstadoActiveDirectory();
        this.obtenerMenuOpciones();

        await this.cargaConfiguraciones();
        await this.cargaParamCallCenter();
        await this.cargaRepartidores();

        this.reloadData();
        this.updateMap();

        if (this.state.parametrosCallCenter && !this.dataUpdate) {
            this.dataUpdate = setInterval(() => {
                this._isMounted && this.reloadData();
            }, (this.state.parametrosCallCenter.ParRefrescaMonitoreo * 1000));
        }
    };

    componentWillUnmount = () => {
        this._isMounted = false;
        if (this.dataUpdate) {
            clearInterval(this.dataUpdate);
        }
    }

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };

    obtenerMenuOpciones = async () => {
        let menuId = 0;
        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        if (menuId > 0) {
            const response = await Obtener_MenuOpciones(this.props.token, menuId);
            if (response.Exitoso) {
                this._isMounted && this.setState({ menuId, opcionesMenu: response.Datos });
            } else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return;
                }
                Notificacion.error(response.Mensaje);
            }
        }
    };

    /**
     * Se actualizan los datos requeridos para el funcionamiento de esta pantalla.
     * */
    reloadData = async () => {


        let reloadedState = {};
        let loadingProcess = (async () => {
            const fecha_activa = new Date();

            let listaOrdenes = Orden.instanciate(await this.cargaOrdenes("'R','F','T'", fecha_activa));

            //  Se obtuvieron órdenes
            if (listaOrdenes && listaOrdenes.length > 0) {
                listaOrdenes.forEach((orden) => orden.Productos = []);

                let productos = await this.obtenerArticulosOrdenes(listaOrdenes);

                //  Inicializar detalle (productos) de cada orden
                productos.forEach((producto) => {
                    listaOrdenes.forEach((orden) => {
                        if (orden.Id === producto.Orden_Id) {
                            orden.Productos.push(producto);
                        }
                    });
                });
            }

            //  Se carga el PushPin de sucursal de la sesión
            let pushPins = [];
            if (this.state.configuraciones) {
                pushPins = [{
                    "location": [parseFloat(this.state.configuraciones.Latitud), parseFloat(this.state.configuraciones.Longitud)],
                    "option": { color: 'black', title: 'Sucursal' }
                }];
            }

            let repartidorList = Repartidor.instanciate(this.state.repartidores ? this.state.repartidores : []);
            //  Se asignan las ordenes a los repartidores y se actualiza el estatus de los mismos así como la disponibilidad
            for (let i = 0; i < repartidorList.length; i++) {
                let courier = repartidorList[i];
                let listaOrdenesTmp = Object.assign([], listaOrdenes);


                listaOrdenesTmp.map((x) => {
                    //  La orden está asignada a este repartidor
                    if (x.Repartidor_Id === courier.Id) {
                        //  Retirar orden de "sin asignar"
                        listaOrdenes.splice(listaOrdenes.findIndex((orderToSplice) => orderToSplice.Id === x.Id), 1);

                        courier.assignOrder(x);

                        //   El repartidor tiene alguna orden en ruta
                        if (x.Estatus === "R") {
                            //  Se define el repartidor como "En Ruta"
                            courier.updateStatus(Constantes.Tipos_Estatus[3]);
                        }
                    }
                });
                if (courier.Disponible) {
                    courier.Disponible = await this.cargaRepartidorInfo(courier);
                }
            }

            let listaOrdenesFilradas = Object.assign([], this.state.listaOrdenesFilradas);

            //  Verificar que las ordenes filtradas existen en la lista principal
            listaOrdenesFilradas = listaOrdenesFilradas.map((orden) => {
                //  La orden existe en la lista principal
                if (listaOrdenes.filter((x) => x.Id === orden.Id).length > 0) {
                    return orden;
                }
            });

            //  Actualizar referencias de objetos de órdenes filtradas con órdenes de lista principal
            listaOrdenesFilradas.forEach((ordenFiltrada) => {
                ordenFiltrada = listaOrdenes.filter((orden) => orden.Id === ordenFiltrada.Id)[0];
            });

            //  Restaurar selecciones de usuario
            let userWorkspace = Object.assign({}, this.state.userWorkspace);

            //  Obtener valores seleccionados luego de actualización
            //  Había datos seleccionados
            if (userWorkspace.selectedCourier || userWorkspace.selectedOrder) {
                let courierFilter = [];
                if (userWorkspace.selectedCourier) {
                    repartidorList.filter((repartidor) => repartidor.Id === userWorkspace.selectedCourier.Id);
                }
                let orderFilter = [];
                if (userWorkspace.selectedOrder) {
                    listaOrdenes.filter((orden) => orden.Id === userWorkspace.selectedOrder.Id);
                }

                //  Los datos seleccionados aún existen luego de actualización
                if (courierFilter.length > 0) {
                    userWorkspace.selectedCourier = courierFilter[0];
                }
                if (orderFilter.length > 0) {
                    userWorkspace.selectedOrder = orderFilter[0];
                }
            }
            reloadedState = {
                pushPins, repartidorList, listaOrdenes, listaOrdenesFilradas,
                fecha_activa, userWorkspace
            };
        })();

        loadingProcess.then(
            () => {
                this._isMounted && this.setState({ loading: true }, () => {
                    this._isMounted && this.setState({ ...reloadedState }, () => {
                        const actualizacionMonitor = Object.assign({}, this.state.actualizacionMonitor);
                        this._isMounted && this.setState({ loading: false }, actualizacionMonitor.notificar ? () => { Notificacion.success(actualizacionMonitor.mensaje) } : () => { });
                    });
                });
            }
        );
    };

    cargaRepartidorInfo = async (repartidor) => {
        if (this.props.token) {

            const response = await Repartidor_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, repartidor.Id);
            if (response.Exitoso) {
                return response.Datos.Estatus !== "I";
            } else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return false;
                }
                Notificacion.error(response.Mensaje);
                return false;
            }
        }
    };

    cargaRepartidores = async () => {
        if (this.props.token) {
            const response = await Obtener_Repartidores(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.sucursal.Id)
            if (response.Exitoso) {
                this.setState({ repartidores: response.Datos });
                return response.Datos;
            } else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    cargaConfiguraciones = async () => {
        if (this.props.token) {
            const response = await Obtener_Configuraciones(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.sucursal.Id);
            if (response.Exitoso) {

                const configuraciones = response.Datos;
                let center = Object.assign([], this.state.center);

                //  Se obtuvieron los datos de configuraciones
                if (configuraciones && configuraciones.Latitud && configuraciones.Longitud) {
                    //  Las coordenadas son válidas
                    if (!isNaN(parseFloat(configuraciones.Latitud)) && !isNaN(parseFloat(configuraciones.Longitud))) {
                        center = [parseFloat(configuraciones.Latitud), parseFloat(configuraciones.Longitud)];

                        const pushPins = [{
                            "location": [parseFloat(configuraciones.Latitud), parseFloat(configuraciones.Longitud)],
                            "option": { color: 'black', title: 'Sucursal' }
                        }];

                        this._isMounted && this.setState({ center, pushPins, configuraciones }, () => this.updateMap());
                    }
                }
            } else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                }
                Notificacion.error(response.Mensaje);
            }
        }
    };

    cargaOrdenes = async (estadosOrden, pFecha) => {
        if (this.props.token) {
            const response = await Obtener_Ordenes_Sin_Asignar(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.props.sucursal.Id, estadosOrden, pFecha);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargaParamCallCenter = async () => {

        if (this.props.token) {
            const response = await ParametroCallCenter_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id);
            if (response) {
                this.setState({ parametrosCallCenter: response });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                }
                Notificacion.error(response.Mensaje);
            }
        }
    }

    obtenerArticulos = async (pOrden) => {
        if (this.props.token) {
            const response = await AR_Obtener_Productos_Orden(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden.Id);
            if (response.Exitoso) {

                const articulosTotales = response.Datos;

                let modals = Object.assign({}, this.state.modals);
                let productsModal = modals["ProductsModal"];
                productsModal.products = articulosTotales;
                productsModal.order = pOrden;

                modals.ProductsModal = productsModal;

                this.setState({ modals }, () => {
                    this.toggleModal("ProductsModal", true, "show");
                    this.setState({ loading: false });
                });

            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                }
                Notificacion.error(response.Mensaje);
            }
        }
        this.setState({ loading: false });
    }

    obtenerArticulosOrdenes = async (ordenes) => {
        if (this.props.token) {
            let ordenesIds = ordenes.map((orden) => { return ("'" + orden.Id + "'") });
            ordenesIds = ordenesIds.join(',');

            const response = await AR_Obtener_Productos_Ordenes(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, ordenesIds);
            if (response.Exitoso) {
                return response.Datos;
            } else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return [];
                }
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    };

    filtraOrdenes = (filtro) => {
        if (filtro) {
            let listaOrdenes = this.state.listaOrdenes;
            let propiedades = { "Id": -1 };
            let ordenesFiltradas = listaOrdenes.filter(orden => Object.keys(propiedades).some(propiedad => orden[propiedad].toString().toLowerCase().includes(filtro.toLowerCase())));

            return ordenesFiltradas;
        } else {
            return [];
        }
    }

    onChangeBuscar = event => {
        const filtro = event.target.value;
        const listaOrdenesFilradas = this.filtraOrdenes(filtro);
        this.setState({ filtro, listaOrdenesFilradas });
    }

    toggleViewAs = (value) => {
        let viewAs = Object.assign({}, this.state.viewAs)

        switch (value) {
            case "Map":
                viewAs.Map = true
                viewAs.List = false
                break;

            case "List":
                viewAs.List = true
                viewAs.Map = false
                break;
        }

        this.setState({ viewAs })
    }

    /**
     * @param event       JavaScript Event Object
     * @param dataObject  must define members:
     *          =>  handler:  method to be called
     */
    handleClickEvent = (event, dataObject) => {

        //  Hay una operación en curso
        if (this.state.loading) {
            Notificacion.error("Hay una operacion en curso. Por favor, reintentelo en breve");
            return;
        }

        switch (dataObject.handler) {
            case "selectCourier":
                this.selectCourier(event, dataObject.data);
                break;

            case "Ordenes Sin Asignar":
                this.selectOrder(event, dataObject.data);
                break;

            case "unassignOrder":
                {
                    let validar = this.validarMenuOpcion(Config.m_Eliminar_Orden_Asignada);
                    if (validar) {
                        this.setState({ unassignOrder: dataObject.data });
                    }
                    else {
                        this.unassignOrder(dataObject.data);
                    }
                    break;
                }
            case "setEnRoute":
                {
                    let modal = Object.assign({}, this.state.modals.RouteModal);

                    //  No se ha interactuado con el modal
                    if (!modal.show) {
                        switch (modal.action) {
                            case "Aplicar":
                                this.setCourierEnRoute();
                                break;

                            default:
                                {
                                    let validar = this.validarMenuOpcion(Config.m_Pasar_A_Ruta);
                                    if (!validar) {
                                        this.toggleModal("RouteModal", true, "");
                                        break;
                                    }
                                }
                        }
                    }
                    break;
                }
            case "finishRoute":
                {
                    let validar = this.validarMenuOpcion(Config.m_Finalizar_Ruta);
                    if (!validar) {

                        this.finishCourierRoute();
                    }
                    break;
                }
            case "showOrderProducts":
                this.showOrderProducts(dataObject.data);
                break;

            case "toggleCollapsible":
                {
                    let collapsibles = Object.assign({}, this.state.collapsibles);

                    collapsibles[dataObject.data.item].show = !collapsibles[dataObject.data.item].show;

                    this.setState({ collapsibles });
                    break;
                }
            case "toggleRouteModalCheck":
                {
                    let updatedModals = Object.assign({}, this.state.modals);
                    let updatedModal = updatedModals["RouteModal"];

                    updatedModal.checks[dataObject.data] = !updatedModal.checks[dataObject.data];
                    updatedModals["RouteModal"] = updatedModal;

                    this.setState({ modals: updatedModals });
                    break;
                }
        }
    }

    toggleModal = (name, willShow, action) => {
        let modals = Object.assign({}, this.state.modals);
        let modal = modals[name];

        modal.show = willShow;
        modal.action = action;

        modals[name] = modal;

        this.setState({ modals }, () => this.performModalAction(name));
    };

    showOrderProducts = (order) => {
        this.setState({ loading: true }, () => {
            this.obtenerArticulos(order);
        });
    };

    performModalAction = (modalName) => {
        let modals = Object.assign({}, this.state.modals);
        let modal = modals[modalName];

        switch (modalName) {
            case "RouteModal":
                switch (modal.action) {
                    case "Aplicar":
                        this.handleClickEvent(null, { handler: "setEnRoute" });
                        this.toggleModal("RouteModal", false, "");
                        this.toggleModal("PrintModal", true, "");
                        break;
                }
                break;
        }
    };

    setCourierEnRoute = () => {
        let userWorkspace = Object.assign({}, this.state.userWorkspace);
        let repartidorList = Object.assign([], this.state.repartidorList);

        repartidorList.forEach((repartidor) => {
            //  Repartidor Seleccionado
            if (repartidor.Id === userWorkspace.selectedCourier.Id) {
                let usuarioTemp = localStorageObject.get("UID");
                usuarioTemp = usuarioTemp ? usuarioTemp : 0;
                localStorageObject.set("UID", -1);

                let ordenes = repartidor.Ordenes.map(orden => { return "'" + orden.Id + "'" });
                let ordenesString = ordenes.join(",");
                let response = (async () => { return AR_Repartidor_En_Ruta(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, repartidor.Id, ordenesString, true, usuarioTemp); })();
                response.then(
                    (data) => {
                        if (data.Exitoso) {

                            repartidor.Ordenes.forEach((orden) => {
                                orden.Estatus = 'R';
                            });
                            repartidor.updateStatus(Constantes.Tipos_Estatus[3]);
                            userWorkspace.selectedCourier = repartidor;

                            setTimeout(() => { this.guardarEntregaRepartidor("RU", false); }, 1500);
                            this.setState({ userWorkspace, repartidorList, loading: false }, () => {
                                Notificacion.success("El repartidor ha pasado a ruta.");
                                this.updateMap();
                            });
                        } else {
                            Notificacion.error("No se ha podido pasar el repartidor a ruta");
                            this.setState({ loading: false });
                        }
                    },
                    (error) => { Notificacion.error(error) }
                );
            }
        });
        this.setState({ loading: true });
    };

    finishCourierRoute = async () => {

        await this.reloadData();
        let userWorkspace = Object.assign({}, this.state.userWorkspace);
        let repartidorList = Object.assign([], this.state.repartidorList);
        let listaOrdenes = Object.assign([], this.state.listaOrdenes);

        repartidorList.forEach((repartidor) => {
            //  Repartidor Seleccionado
            if (repartidor.Id === userWorkspace.selectedCourier.Id) {
                let usuarioTemp = localStorageObject.get("UID");
                usuarioTemp = usuarioTemp ? usuarioTemp : 0;
                localStorageObject.set("UID", -1);

                let ordenes = repartidor.Ordenes.map(orden => { return `'${orden.Id}'`; });
                let ordenesString = ordenes.join(",");
                let response = (async () => { return AR_Repartidor_En_Ruta(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, repartidor.Id, ordenesString, false, usuarioTemp); })();
                response.then(
                    (data) => {
                        if (data.Exitoso) {
                            this.guardarEntregaRepartidor("BO", false);
                            this.setState({ infoRoutes: [] });
                            let finishedOrders = repartidor.Ordenes;
                            repartidor.Ordenes = [];

                            listaOrdenes = listaOrdenes.concat(finishedOrders);
                            repartidor.updateStatus();

                            userWorkspace.selectedCourier = repartidor;

                            this.setState({ userWorkspace, repartidorList, listaOrdenes, loading: false }, () => {
                                Notificacion.success("Se ha anulado la ruta con éxito.");
                                this.updateMap()
                            });
                        } else {

                            if (data.Mensaje.indexOf("No se encontraron órdenes") != -1) {

                                let userWorkspace = Object.assign({}, this.state.userWorkspace);
                                repartidor.Ordenes = [];
                                userWorkspace.selectedCourier = repartidor;
                                this.setState({ userWorkspace, loading: false }, () => {
                                    this.updateMap();
                                });
                            }
                            Notificacion.error(data.Mensaje);
                            this.setState({ loading: false });
                        }
                    },
                    (error) => { Notificacion.error(error) }
                );
            }
        });

        this.setState({ loading: true });
    };

    selectCourier = (event, dataObject) => {
        let userWorkspace = Object.assign({}, this.state.userWorkspace);

        //  Si el repartidor que el usuario desea seleccionar, ya lo estaba previamente, se cancela la selección
        userWorkspace.selectedCourier = (userWorkspace.selectedCourier && (userWorkspace.selectedCourier.Id == dataObject.Id)) ? null : dataObject;

        this.setState({ userWorkspace }, () => this.updateMap());
    }

    selectOrder = (event, dataObject) => {
        let userWorkspace = Object.assign({}, this.state.userWorkspace)

        //  Si la orden que el usuario desea seleccionar, ya lo estaba previamente, se cancela la selección
        userWorkspace.selectedOrder = (userWorkspace.selectedOrder && (userWorkspace.selectedOrder.Id == dataObject.Id)) ? null : dataObject;

        this.setState({ userWorkspace })
    }

    toggleInfobox = ({ location, orden }) => {

        let visible = true;

        let infoboxes = [
            {
                //"location": [orden.Ruta.Coordenada.Latitud, orden.Ruta.Coordenada.Longitud],
                //----------- TESTING PURPOSE ---------------------
                "location": location,
                //-------------------------------------------------
                "maxHeight": "500px",
                "maxWidth": "500px",
                "option": {
                    visible: visible, title: `Información de Orden`,
                    "maxHeight": "500px", "maxWidth": "500px",
                    description: `
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="row" style="color:blue;">
                                                <div class="col-12">
                                                    <strong style="color: #4C7EF8;">#${orden.Id}</strong>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    ${orden.Fecha_Creacion}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    ${this.props.simboloMoneda} ${Numeral(orden.Monto.Valor).format('0,0.00')}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    ${orden.Tipo_Pago.Contado ? "Contado" : "Cr\u00e9dito"}
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    ${orden.Estatus === "R" ? "En Ruta" : "Facturado"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                    `,
                    actions: [
                        { label: "Remover", eventHandler: (e) => { this.handleClickEvent(e, { handler: "unassignOrder", data: orden }) } },
                        { label: "Ver Detalle", eventHandler: (event) => { this.handleClickEvent(event, { handler: "showOrderProducts", data: orden }) } }
                    ]
                }

            }
        ];

        this.setState({ infoboxes });
    }

    updateMap = () => {

        let selectedCourier = this.state.userWorkspace.selectedCourier;


        //  Existe un repartidor seleccionado y está seleccionado como En RUta.
        if (selectedCourier && selectedCourier.Estatus === Constantes.Tipos_Estatus[3]) {

            let pushPins = [];
            let sucursalPushPin = [Object.assign([], this.state.pushPins)[0]];
            let _locationSucursal = sucursalPushPin[0].location

            let _Ordenes = selectedCourier.Ordenes;


            _Ordenes = selectedCourier.Ordenes.sort((a, b) => {
                return a.Orden_Id - b.Orden_Id
            })

            let _findOrdenOld = {};
            let _parametroXSucursal = true;
            if (_Ordenes.length > 0) {
                _findOrdenOld = _Ordenes[0];
                _parametroXSucursal = _findOrdenOld.ParControlRepartidorXSucursal;
            }

            /*- Por Sucursal: Funcionalidad Actual.
                - Por Call Center:
                    - Se debe determinar la orden más vieja para obtener la sucursal de salida.
                    - Posteriormenten se aplica ordenamiento por sucursal en base a la distancia.
                    - Luego se aplica agrupación de órdenes por sucursal por órden más vieja.*/

            if (!_parametroXSucursal) {  //Si es por callcenter

                //Sucursale de partida push pins
                let _pushPingsSucursales = [];
                let _sucursalPartida = { Suc_Id: _findOrdenOld.Suc_Factura, Ruta: { Coordenada: { Latitud: _findOrdenOld.Ubicacion_Suc.Latitud, Longitud: _findOrdenOld.Ubicacion_Suc.Longitud }, Direccion: "" } };
                _pushPingsSucursales.push(_sucursalPartida);


                //siguientes sucursales
                _Ordenes.map(item => {
                    let _finded = _pushPingsSucursales.find(x => x.Suc_Id === item.Suc_Factura);
                    if (item.Suc_Factura !== _sucursalPartida.Suc_Id) {
                        if (_finded === undefined) {
                            _pushPingsSucursales.push({ Suc_Id: item.Suc_Factura, Ruta: { Coordenada: { Latitud: item.Ubicacion_Suc.Latitud, Longitud: item.Ubicacion_Suc.Longitud }, Direccion: "" } })
                        }
                    }
                });

                let _Sucursales = _pushPingsSucursales;
                let _OrdenesSucursales = [];

                _Sucursales.map(item => {
                    _OrdenesSucursales.push(item);
                    let _ordenesSuc = _Ordenes.filter(x => x.Suc_Factura == item.Suc_Id);
                    _ordenesSuc.map(a => {
                        _OrdenesSucursales.push(a)
                    })
                });

                _Ordenes = _OrdenesSucursales;
            }

            let ordenesPushPins = _Ordenes.map(orden => {

                let _locationOrden = [0, 0]
                if (orden.Ruta.Coordenada.Latitud == 0 && orden.Ruta.Coordenada.Longitud == 0) {
                    _locationOrden = _locationSucursal;
                } else {
                    _locationOrden = [orden.Ruta.Coordenada.Latitud, orden.Ruta.Coordenada.Longitud]
                }

                let _icono = ImagenesRutas.Ping;
                let _title = orden.Ruta.Direccion;
                if (orden.Suc_Id) {
                    _icono = ImagenesRutas.PingSucursal;
                    _title = "SUCURSAL";
                }
                _icono = "";
                return {
                    "location": _locationOrden,
                    "option": { color: 'black', title: _title, icon: _icono },
                    "addHandler": { "type": "click", callback: () => this.toggleInfobox({ location: _locationOrden, orden: orden }) }
                }
            });

            pushPins = sucursalPushPin.concat(ordenesPushPins);

            if (_parametroXSucursal) {  //Si es por callcenter

                pushPins = sucursalPushPin.concat(ordenesPushPins);
            } else {
                pushPins = ordenesPushPins;
            }

            let directions = {};

            let wayPoints = pushPins.map(pushPin => {
                return {
                    "option": { visible: false, color: 'black' },
                    "location": [pushPin.location[0], pushPin.location[1]], address: pushPin.option.title,
                    "addHandler": { "type": "click", callback: () => this.toggleInfobox({ location: [orden.Ruta.Coordenada.Latitud, orden.Ruta.Coordenada.Longitud], orden: orden }) }
                }
            });
            directions = wayPoints.length > 0 ? {
                "renderOptions": { "itineraryContainer": "itineraryContainer" },
                "requestOptions": { "option": { visible: false }, "routeMode": "driving", "maxRoutes": 1, "distanceUnit": "km" },
                "wayPoints": wayPoints
            } : {};

            let mapRenderKey = this.state.mapRenderKey;
            mapRenderKey = mapRenderKey === 0 ? 1 : 0;
            this.setState({ directions, mapRenderKey }, () => { this.setState({ pushPins }) });
        } else {
            let mapRenderKey = this.state.mapRenderKey;

            //  Desmontar mapa solo si hay rutas marcadas (directions)
            //if (!this.state.directions.wayPoints) {
            mapRenderKey = mapRenderKey === 0 ? 1 : 0;
            //}

            let sucursalPushPin = [Object.assign([], this.state.pushPins)[0]];
            this.setState({ mapRenderKey, pushPins: sucursalPushPin, directions: {}, infoboxes: [] });
        }
    }

    asignarOrdenAction = (eventTarget) => {
        const { parametrosCallCenter } = this.state;

        let knownEventTargets = ["btnAssignSingleOrder", "btnAssignMultipleOrders"];
        let listaOrdenes = Object.assign([], this.state.listaOrdenes);
        let listaOrdenesFilradas = Object.assign([], this.state.listaOrdenesFilradas);
        let userWorkspace = Object.assign({}, this.state.userWorkspace);
        let repartidorList = Object.assign([], this.state.repartidorList);
        let ordenesMaximas = parametrosCallCenter ? parametrosCallCenter.Orden_x_repartidor : 0;
        let montoMaximo = parametrosCallCenter ? parametrosCallCenter.Monto_x_repartidor : 0;
        let montoActual = 0;
        let montoProyectado = 0;

        //  El usuario seleccionó al menos un reartidor
        if (userWorkspace.selectedCourier) {

            repartidorList.forEach(repartidor => {
                //  Repartidor Seleccionado
                if (repartidor.Id == userWorkspace.selectedCourier.Id) {
                    //  El repartidor no está disponible
                    if (!repartidor.Disponible) {
                        Notificacion.error("El repartidor seleccionado no está disponible.");
                        return;
                    }

                    repartidor.Ordenes.forEach(orden => {
                        if (orden.Tipo_Pago.Tipo === "CO") {
                            montoActual += orden.Monto.Valor;
                        }

                    });

                    let usuarioTemp = localStorageObject.get("UID");
                    usuarioTemp = usuarioTemp ? usuarioTemp : 0;
                    localStorageObject.set("UID", -1);

                    //  Asignar Orden Específica
                    if (userWorkspace.selectedOrder && eventTarget === knownEventTargets[0]) {
                        //  El repartidor aún no ha llegadó al límite de órdenes ni monto

                        let montoOrden2 = userWorkspace.selectedOrder.Tipo_Pago.Tipo === "CO" ? userWorkspace.selectedOrder.Monto.Valor : 0;
                        if (repartidor.Ordenes.length + 1 <= ordenesMaximas && (montoActual + montoOrden2) <= montoMaximo) {
                            //  Se asignó la orden en la base de datos
                            this.setState({ loading: true });
                            let response = (async () => await AR_Asignar_Repartidor(
                                this.props.token, this.props.empresa.Id, this.props.callCenter.Id,
                                this.props.sucursal.Id, userWorkspace.selectedOrder.Id, repartidor.Id, false, usuarioTemp
                            )
                            )();
                            response.then(
                                (value) => {
                                    if (value.Datos) {
                                        if (value.Exitoso) {

                                            if (value.Datos.indexOf("Error:") == -1) {
                                                repartidor.assignOrder(listaOrdenes.splice(listaOrdenes.findIndex((orden) => orden.Id == userWorkspace.selectedOrder.Id), 1)[0]);
                                                listaOrdenesFilradas.splice(listaOrdenesFilradas.findIndex((orden) => orden.Id == userWorkspace.selectedOrder.Id), 1);
                                                userWorkspace.selectedOrder = null;
                                                userWorkspace.selectedCourier = repartidor;
                                                this.setState({ listaOrdenes, userWorkspace, repartidorList, listaOrdenesFilradas, loading: false }, () => { this.updateMap() });

                                                if (value.Datos.indexOf("Success:") != -1) {
                                                    Notificacion.success(value.Datos.replace("Success:", ""))
                                                }

                                            } else {
                                                Notificacion.error(value.Datos.replace("Error:", ""))
                                            }


                                            this.reloadData()

                                        }

                                    }
                                },
                                (reason) => { Notificacion.error(reason) }
                            );
                        } else {
                            //  Se excedió el monto que se puede asignar a un repartidor
                            let montoOrden = userWorkspace.selectedOrder.Tipo_Pago.Tipo === "CO" ? userWorkspace.selectedOrder.Monto.Valor : 0;
                            if (!((montoActual + montoOrden) <= montoMaximo)) {
                                Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.monto);
                            } else {
                                //  Se excedió la cantidad de ordenes que se pueden asignar
                                if (!(repartidor.Ordenes.length + 1 <= ordenesMaximas)) {
                                    Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.cantidadOrdenes);
                                }
                            }
                        }
                    } else {
                        if (eventTarget === knownEventTargets[1]) {

                            listaOrdenes.forEach((orden) => {
                                if (orden.Tipo_Pago.Tipo === "CO") {
                                    montoProyectado += orden.Monto.Valor;
                                }
                            });

                            montoProyectado += montoActual;

                            //  El monto se encuentra en el rango permitido en parámetros de Call Center
                            if (montoProyectado <= montoMaximo) {
                                //  La asignación no excede al límite
                                if (repartidor.Ordenes.length + listaOrdenes.length <= ordenesMaximas) {
                                    let listaOrdenesIds = listaOrdenes.map((value, index) => { return value.Id });
                                    this.setState({ loading: true });
                                    let response = (async () => await AR_Asignar_Repartidor(
                                        this.props.token, this.props.empresa.Id, this.props.callCenter.Id,
                                        this.props.sucursal.Id, listaOrdenesIds.join(","), repartidor.Id, false, usuarioTemp
                                    ))();
                                    response.then(
                                        (value) => {
                                            //  La operación se realizó en la base de datos
                                            if (value.Datos) {

                                                if (value.Datos.indexOf("Success:") != -1) {
                                                    Notificacion.success(value.Datos.replace("Success:", ""));

                                                    repartidor.Ordenes = listaOrdenes;
                                                    repartidor.updateStatus();
                                                    userWorkspace.selectedCourier = repartidor;
                                                    userWorkspace.selectedOrder = null;
                                                    listaOrdenes = [];
                                                    this.setState({ listaOrdenes, repartidorList, userWorkspace, loading: false }, () => { this.updateMap() });




                                                } else
                                                    if (value.Datos.indexOf("Error:") != -1) {



                                                        Notificacion.error(value.Datos.replace("Error:", ""))
                                                    }



                                                this.reloadData()

                                                // if (value.Exitoso) {

                                                //  }

                                            }
                                        },
                                        (reason) => { Notificacion.error(reason) }
                                    );
                                } else {
                                    Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.cantidadOrdenes);
                                }
                            } else {
                                Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.monto);
                            }
                        } else {
                            Notificacion.error(this.state.mensajesError.repartidor.indefinido.ordenSeleccionada);
                        }
                    }
                    userWorkspace.selectedCourier = Object.assign({}, repartidor);
                }
            });
        } else {
            Notificacion.error(this.state.mensajesError.repartidor.indefinido.repartidorSeleccionado);
        }
    }

    asignarOrdenActionEnRuta = async (eventTarget) => {
        const { parametrosCallCenter } = this.state;

        let knownEventTargets = ["btnAssignSingleOrder", "btnAssignMultipleOrders"];
        let listaOrdenes = Object.assign([], this.state.listaOrdenes);
        let listaOrdenesFilradas = Object.assign([], this.state.listaOrdenesFilradas);
        let userWorkspace = Object.assign({}, this.state.userWorkspace);
        let repartidorList = Object.assign([], this.state.repartidorList);
        let ordenesMaximas = parametrosCallCenter ? parametrosCallCenter.Orden_x_repartidor : 0;
        let montoMaximo = parametrosCallCenter ? parametrosCallCenter.Monto_x_repartidor : 0;
        let montoActual = 0;
        let montoProyectado = 0;

        //  El usuario seleccionó al menos un reartidor
        if (userWorkspace.selectedCourier) {

            repartidorList.forEach(repartidor => {
                //  Repartidor Seleccionado
                if (repartidor.Id == userWorkspace.selectedCourier.Id) {
                    //  El repartidor no está disponible
                    if (!repartidor.Disponible) {
                        Notificacion.error("El repartidor seleccionado no está disponible.");
                        return;
                    }

                    repartidor.Ordenes.forEach(orden => {
                        if (orden.Tipo_Pago.Tipo === "CO") {
                            montoActual += orden.Monto.Valor;
                        }
                    });

                    let usuarioTemp = localStorageObject.get("UID");
                    usuarioTemp = usuarioTemp ? usuarioTemp : 0;
                    localStorageObject.set("UID", -1);

                    //  Asignar Orden Específica
                    if (userWorkspace.selectedOrder && eventTarget === knownEventTargets[0]) {
                        //  El repartidor aún no ha llegadó al límite de órdenes ni monto
                        let montoOrden2 = userWorkspace.selectedOrder.Tipo_Pago.Tipo === "CO" ? userWorkspace.selectedOrder.Monto.Valor : 0;
                        if (repartidor.Ordenes.length + 1 <= ordenesMaximas && (montoActual + montoOrden2) <= montoMaximo) {
                            //  Se asignó la orden en la base de datos
                            this.setState({ loading: true });
                            let response = (async () => await AR_Asignar_Repartidor(
                                this.props.token, this.props.empresa.Id, this.props.callCenter.Id,
                                this.props.sucursal.Id, userWorkspace.selectedOrder.Id, repartidor.Id, true, usuarioTemp))();

                            response.then(
                                (value) => {
                                    if (value.Datos) {

                                        repartidor.assignOrder(listaOrdenes.splice(listaOrdenes.findIndex((orden) => orden.Id == userWorkspace.selectedOrder.Id), 1)[0]);
                                        listaOrdenesFilradas.splice(listaOrdenesFilradas.findIndex((orden) => orden.Id == userWorkspace.selectedOrder.Id), 1);
                                        userWorkspace.selectedOrder = null;
                                        repartidor.updateStatus(Constantes.Tipos_Estatus[3]);


                                        userWorkspace.selectedCourier = repartidor;
                                        userWorkspace.selectedCourier.Ordenes = userWorkspace.selectedCourier.Ordenes.map(o => {

                                            if (o.Estatus !== "T") {
                                                return {
                                                    ...o,
                                                    Estatus: "R"
                                                }
                                            } else {
                                                return o
                                            }


                                        });
                                        this.setState({ listaOrdenes, userWorkspace, repartidorList, listaOrdenesFilradas, loading: false }, () => { this.updateMap(); });
                                        setTimeout(() => { this.guardarEntregaRepartidor("RU", true); }, 2000);

                                    }
                                },
                                (reason) => { Notificacion.error(reason) }
                            );
                        } else {
                            //  Se excedió el monto que se puede asignar a un repartidor
                            let montoOrden = userWorkspace.selectedOrder.Tipo_Pago.Tipo === "CO" ? userWorkspace.selectedOrder.Monto.Valor : 0;
                            if (!((montoActual + montoOrden) <= montoMaximo)) {
                                Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.monto);
                            } else {
                                //  Se excedió la cantidad de ordenes que se pueden asignar
                                if (!(repartidor.Ordenes.length + 1 <= ordenesMaximas)) {
                                    Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.cantidadOrdenes);
                                }
                            }
                        }
                    } else {
                        if (eventTarget === knownEventTargets[1]) {

                            listaOrdenes.forEach((orden) => {

                                if (orden.Tipo_Pago.Tipo === "CO") {
                                    montoProyectado += orden.Monto.Valor;
                                }
                            });

                            montoProyectado += montoActual;

                            //  El monto se encuentra en el rango permitido en parámetros de Call Center
                            if (montoProyectado <= montoMaximo) {
                                //  La asignación no excede al límite
                                if (repartidor.Ordenes.length + listaOrdenes.length <= ordenesMaximas) {
                                    let listaOrdenesIds = listaOrdenes.map(value => { return value.Id });
                                    this.setState({ loading: true });
                                    let response = (async () => await AR_Asignar_Repartidor(
                                        this.props.token, this.props.empresa.Id, this.props.callCenter.Id,
                                        this.props.sucursal.Id, listaOrdenesIds.join(","), repartidor.Id, true, usuarioTemp
                                    ))();
                                    response.then(
                                        (value) => {

                                            //  La operación se realizó en la base de datos
                                            let _OrdenesRutas = [...repartidor.Ordenes, ...listaOrdenes];
                                            if (value.Datos) {
                                                repartidor.Ordenes = _OrdenesRutas.map(o => { return { ...o, Estatus: "R" } });
                                                repartidor.updateStatus(Constantes.Tipos_Estatus[3]);
                                                userWorkspace.selectedCourier = repartidor;
                                                userWorkspace.selectedCourier.Ordenes = userWorkspace.selectedCourier.Ordenes.map(o => {

                                                    if (o.Estatus !== "T") {
                                                        return {
                                                            ...o,
                                                            Estatus: "R"
                                                        }
                                                    } else {
                                                        return o
                                                    }
                                                });
                                                listaOrdenes = [];
                                                this.setState({ listaOrdenes, repartidorList, userWorkspace, loading: false }, () => { this.updateMap(); });
                                                setTimeout(() => { this.guardarEntregaRepartidor("RU", true); }, 2000);
                                            }
                                        },
                                        (reason) => { Notificacion.error(reason) }
                                    );
                                } else {
                                    Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.cantidadOrdenes);
                                }
                            } else {
                                Notificacion.error(this.state.mensajesError.repartidor.limiteExcedido.monto);
                            }
                        } else {
                            Notificacion.error(this.state.mensajesError.repartidor.indefinido.ordenSeleccionada);
                        }
                    }
                    userWorkspace.selectedCourier = Object.assign({}, repartidor);
                }
            });
        } else {
            Notificacion.error(this.state.mensajesError.repartidor.indefinido.repartidorSeleccionado);
        }
    }

    assignOrder = (eventTarget) => {

        let knownEventTargets = ["btnAssignSingleOrder", "btnAssignMultipleOrders"];
        let listaOrdenes = Object.assign([], this.state.listaOrdenes);
        let userWorkspace = Object.assign({}, this.state.userWorkspace);

        if (eventTarget === knownEventTargets[0]) {
            if (userWorkspace.selectedOrder === null) {
                Notificacion.error(this.state.mensajesError.repartidor.indefinido.ordenSeleccionada);
                return;
            }
        }

        if (eventTarget === knownEventTargets[1]) {
            if (listaOrdenes.length === 0) {
                Notificacion.error(this.state.mensajesError.repartidor.indefinido.ordenSeleccionada);
                return;
            }
        }

        if (userWorkspace.selectedCourier) {
            if (userWorkspace.selectedCourier.Estatus === "En Ruta" && userWorkspace.selectedCourier.Disponible) {
                let validar = this.validarMenuOpcion(Config.m_Asignar_Orden_Repartidor_Ruta);
                if (validar) {
                    this.setState({ eventTarget: eventTarget });
                } else {
                    this.asignarOrdenActionEnRuta(eventTarget)
                }
            } else {
                this.asignarOrdenAction(eventTarget);
            }
        }
    }

    unassignOrder = async (selectedOrder) => {
        let userWorkspace = Object.assign({}, this.state.userWorkspace);
        let listaOrdenes = Object.assign([], this.state.listaOrdenes);
        let repartidorList = Object.assign([], this.state.repartidorList);
        var emp_id = this.props.empresa.Id;
        var suc_id = this.props.sucursal.Id;
        var cc_id = this.props.callCenter.Id;
        repartidorList.forEach(async (repartidor) => {
            //  Repartidor seleccionado
            if (repartidor.Id === userWorkspace.selectedCourier.Id) {


                //Si es la ultima ornde en ruta, se finaliza la ruta
                let courierWasEnRoute = repartidor.Estatus === Constantes.Tipos_Estatus[3];
                let ordenesEnRuta = repartidor.Ordenes.filter((orden) => { return (orden.Estatus === "R" || orden.Estatus === "T") }).length;
                if (ordenesEnRuta === 1 && courierWasEnRoute) {
                    this.finishCourierRoute();
                    return;
                }

                if (courierWasEnRoute) {
                    var _Entrega = {
                        Emp_Id: emp_id,
                        Suc_Id: suc_id,
                        CC_Id: cc_id,
                        Estado: "",
                        Repartidor_Id: repartidor.Id
                    }

                    let _Orden = { Orden_Id: selectedOrder.Id, Monto: selectedOrder.Monto.Valor, Estatus: selectedOrder.Estatus, Tipo: selectedOrder.Tipo_Pago.Tipo };
                    let responseEliminarOrdenRuta = await Eliminar_Orden_Entrega_Ruta(this.props.token, JSON.stringify(_Entrega), JSON.stringify(_Orden));

                    if (responseEliminarOrdenRuta.Mensaje) {
                        Notificacion.error(responseEliminarOrdenRuta.Mensaje);
                        return;
                    } else {
                        Notificacion.success("Debe comunicarse con el repartidor para que no realice la entrega de la orden")
                    }
                }

                let response = (async () => await AR_Desasignar_Repartidor(
                    this.props.token, this.props.empresa.Id, this.props.callCenter.Id,
                    this.props.sucursal.Id, selectedOrder.Id, repartidor.Id
                )
                )();

                response.then(
                    (data) => {
                        //  Se modificó el registro en Base de Datos
                        if (data == "") {

                            repartidor.unassignOrder(selectedOrder);

                            //  El repartidor estaba en ruta y aún tiene ordenes en ruta asignadas; se debe restaurar el estatus
                            if (courierWasEnRoute && repartidor.Ordenes.filter((orden) => { return (orden.Estatus === "R" || orden.Estatus === "T") }).length > 0) {
                                repartidor.updateStatus(Constantes.Tipos_Estatus[3]);
                            }

                            userWorkspace.selectedCourier = Object.assign({}, repartidor);
                            selectedOrder.Estatus = "F";
                            listaOrdenes.push(selectedOrder);
                            this.setState({ userWorkspace, listaOrdenes, loading: false, unassignOrder: null }, userWorkspace.selectedCourier ? () => this.updateMap() : () => { });
                        } else {

                            userWorkspace.selectedCourier = Object.assign({}, repartidor);
                            this.setState({ userWorkspace, loading: false, unassignOrder: null }, userWorkspace.selectedCourier ? () => this.updateMap() : () => { });

                            Notificacion.error(data);

                        }
                    },
                    (error) => { Notificacion.error(error); }
                );

                this.setState({ loading: true })
            }
        });
    }

    guardarEntregaRepartidor = async (estado, enRuta = false) => {
        let userWorkspace = Object.assign({}, this.state.userWorkspace);
        let ordenes = userWorkspace.selectedCourier.Ordenes;

        var repartidor = userWorkspace.selectedCourier;

        var emp_id = this.props.empresa.Id;
        var suc_id = this.props.sucursal.Id;
        var cc_id = this.props.callCenter.Id;

        var _Entrega = {
            Emp_Id: emp_id,
            Suc_Id: suc_id,
            CC_Id: cc_id,
            Estado: estado,
            Repartidor_Id: repartidor.Id
        }

        var _Detalle = [];


        var indexInfo = 0;
        ordenes.map(orden => {
            if (this.state.infoRoutes.length === ordenes.length) {
                var _info = this.state.infoRoutes[indexInfo];
                if (_info) {
                    var distancia = Math.round(_info.summary.distance * 100) / 100 + " KM"
                    var duracion = Math.round((_info.summary.time / 60) * 100) / 100 + " MIN"
                    _Detalle.push({ Orden_Id: orden.Id, Estatus: orden.Estatus, Total_Distancia: distancia, Total_Duracion: duracion, Tipo: orden.Tipo_Pago.Tipo });
                } else {
                    _Detalle.push({ Orden_Id: orden.Id, Estatus: orden.Estatus, Total_Distancia: "", Total_Duracion: "", Tipo: orden.Tipo_Pago.Tipo });
                }

            } else {
                _Detalle.push({ Orden_Id: orden.Id, Estatus: orden.Estatus, Total_Distancia: "", Total_Duracion: "", Tipo: orden.Tipo_Pago.Tipo });
            }

            indexInfo++;
        });


        let respuesta = await Guardar_Entrega_Repartidores(this.props.token, JSON.stringify(_Entrega), JSON.stringify(_Detalle), enRuta);
        if (respuesta.Mensaje) {
            Notificacion.error(respuesta.Mensaje);
        }
    }

    Obtener_Distancia = (point1, point2) => {
        const EarthRadius = 6371;
        var distance = 0;
        var Lat = (point2.Latitude - point1.Latitude) * (Math.PI / 180);
        var Lon = (point2.Longitude - point1.Longitude) * (Math.PI / 180);
        var a = Math.sin(Lat / 2) * Math.sin(Lat / 2) + Math.cos(point1.Latitude * (Math.PI / 180)) * Math.cos(point2.Latitude * (Math.PI / 180)) * Math.sin(Lon / 2) * Math.sin(Lon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        distance = EarthRadius * c;
        return distance;
    }

    getInfoRoutes = (legs) => {
        this.setState({ infoRoutes: legs })
    }

    /* Modal Seguridad */
    validarMenuOpcion = opcionId => {
        let validar = false;

        const resultado = this.state.opcionesMenu && this.state.opcionesMenu.length > 0 ? this.state.opcionesMenu.filter(item => item.Opcion_Id === opcionId) : [];
        if (resultado.length > 0) {
            if (resultado[0].Validar) {
                this.setState({ showModalSeguridad: true, opcionId: resultado[0].Opcion_Id });
                validar = true;
            }
        } else {
            this.setState({ showModalSeguridad: true, opcionId: 1 });
            validar = true;
        }

        return validar;
    };

    onActionResultModal = (autorizado) => {
        if (autorizado) {
            const opcionId = this.state.opcionId;
            this.setState({ showModalSeguridad: false, opcionId: -1 });
            switch (opcionId) {
                case Config.m_Asignar_Orden_Repartidor_Ruta:
                    this.asignarOrdenActionEnRuta(this.state.eventTarget);
                    this.setState({ eventTarget: {} });
                    break;
                case Config.m_Pasar_A_Ruta:
                    this.toggleModal("RouteModal", true, "");
                    break;
                case Config.m_Finalizar_Ruta:
                    this.finishCourierRoute();
                    break;
                case Config.m_Eliminar_Orden_Asignada:
                    this.unassignOrder(this.state.unassignOrder);
                    break;
                default:
                    break;
            }
        }
    }

    handleCerrarModal = () => this.setState({ showModalSeguridad: false });
    /*  ===== DOM Events  ===== */

    render() {
        const { listaOrdenesFilradas, infoboxes, pushPins, directions, center, fecha_activa, parametrosCallCenter,
            filtro, mapRenderKey, viewAs, repartidorList, userWorkspace, listaOrdenes, modals, collapsibles, loading, showModalSeguridad, menuId, opcionId
        } = this.state;

        return (
            <Fragment>

                <ConsultaRepartidoresInt
                    /*  State Values  */
                    bingmapKey={parametrosCallCenter ? parametrosCallCenter.Maps_Key : ''}
                    infoboxes={infoboxes}
                    pushPins={pushPins}
                    directions={directions}
                    center={center}
                    fecha_activa={fecha_activa}
                    filtro={filtro}
                    viewAs={viewAs}
                    repartidorList={repartidorList}
                    userWorkspace={userWorkspace}
                    listaOrdenes={listaOrdenes}
                    modals={modals}
                    listaOrdenesFiltradas={listaOrdenesFilradas}
                    collapsibles={collapsibles}
                    loading={loading}
                    mapRenderKey={mapRenderKey}
                    sucursal={this.props.sucursal}
                    infoRoutes={this.getInfoRoutes}
                    /*  State Values  */

                    /*  Methods */
                    toggleViewAs={this.toggleViewAs}
                    handleClickEvent={this.handleClickEvent}
                    assignOrder={this.assignOrder}
                    toggleModal={this.toggleModal}
                    onChangeBuscar={this.onChangeBuscar}
                /*  Methods */
                />


                <ModalSeguridad
                    modalTitle={opcionId === Config.m_Asignar_Orden_Repartidor_Ruta ? "Agregar órdenes a ruta del repartidor" : null}
                    okButtonLabel={opcionId === Config.m_Asignar_Orden_Repartidor_Ruta ? "Aplicar" : null}
                    cancelButtonLabel={opcionId === Config.m_Asignar_Orden_Repartidor_Ruta ? "Cancelar" : null}
                    show={showModalSeguridad}
                    menuId={menuId}
                    opcionId={opcionId}
                    token={this.props.token}
                    onActionResult={this.onActionResultModal}
                    onHide={this.handleCerrarModal}
                    activoAD={this.state.activoAD}
                />

            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter,
        simboloMoneda: state.parametros.simboloMoneda
    };
};

export default connect(mapStateToProps)(withRouter(memo(ConsultaRepartidores)));
